import BrowserUtil from './BrowserUtil';
import BrowserStorageUtil from './BrowserStorageUtil';

var UserStorageUtil = function(){

	var userDataKey = "USER_SESSION";

	var getAuthToken = function(){
		return BrowserUtil.getAuthToken();
	};

	setTimeout(function(){
		try{
			var allData = {};
			try {
				allData = JSON.parse(BrowserStorageUtil.getStoredItem(userDataKey));
			} catch(e){}

			if(allData !== null && typeof allData === "object"){
				for(var i in allData){
					if(i !== getAuthToken()){
						delete allData[i];
					}
				}
				BrowserStorageUtil.storeItem(userDataKey, JSON.stringify(allData));
			}
		}catch(e){}
	}, 5000);

	return{
		storeSessionItem:function(itemKey, itemValue){
			try{
				var allUserData = {};
				try {
					allUserData = JSON.parse(BrowserStorageUtil.getStoredItem(userDataKey));
				} catch (e) {}
				if(allUserData == null){
					allUserData = {};
				}

				var myStoreObj = allUserData[getAuthToken()] || {};
				myStoreObj[itemKey] = itemValue;
				allUserData[getAuthToken()] = myStoreObj;
				BrowserStorageUtil.storeItem(userDataKey,JSON.stringify(allUserData));
			}catch(e){
				if(console)
					console.error(e);
			}
		},
		getStoredSessionItem:function(itemKey){
			try{
				var allUserData = {};
				try {
					allUserData = JSON.parse(BrowserStorageUtil.getStoredItem(userDataKey));
				} catch (e) {}
				if(allUserData === null){
					allUserData = {};
				}

				var myStoreObj = allUserData[getAuthToken()] || {};

				if(myStoreObj[itemKey] !== undefined && myStoreObj[itemKey] !== null ){
					return myStoreObj[itemKey];
				}else{
					return null;
				}
				
			}catch(e){
				if(console)
					console.error(e);
			}
		},
		deleteSessionItem: function(itemKey){
			try{
				var allUserData = {};
				try {
					allUserData = JSON.parse(BrowserStorageUtil.getStoredItem(userDataKey));
				} catch (e) {}
				if(allUserData == null){
					allUserData = {};
				}

				var myStoreObj = allUserData[getAuthToken()] || {};
				delete myStoreObj[itemKey];
				allUserData[getAuthToken()] = myStoreObj;
				BrowserStorageUtil.storeItem(userDataKey,JSON.stringify(allUserData));
			}catch(e){
				if(console)
					console.error(e);
			}
		},
		clearSessionStorage: function(){
			try{
				BrowserStorageUtil.removeItem(userDataKey);
			}catch(e){
				if(console)
					console.error(e);
			}
		}
	};
}();

export default UserStorageUtil;


// WEBPACK FOOTER //
// ./src/util/UserStorageUtil.js